(function ($) {

    $(document).gp_ready(function (){

        if ($('.hero-slider').length) {
            const heroSwiper = $('.hero-slider .swiper-container').get(0).swiper;
            heroSwiper.params.autoplay.disableOnInteraction = false;
            heroSwiper.autoplay.start();
        }

    });

})(jQuery)